import Configuration from '../config';

const PRECONNECT_MARK = 'data-replayer-video-preconnect';

const getOrigin = value => {
  try {
    return new URL(value, window.location.origin).origin;
  } catch (error) {
    return null;
  }
};

const appendLink = (rel, href) => {
  if (!href || typeof document === 'undefined') {
    return;
  }

  const selector = `link[${PRECONNECT_MARK}="${rel}:${href}"]`;
  if (document.head.querySelector(selector)) {
    return;
  }

  const link = document.createElement('link');
  link.rel = rel;
  link.href = href;
  link.setAttribute(PRECONNECT_MARK, `${rel}:${href}`);
  if (rel === 'preconnect') {
    link.crossOrigin = 'anonymous';
  }
  document.head.appendChild(link);
};

export const preconnectVideoPlayer = () => {
  if (typeof window === 'undefined') {
    return;
  }

  [
    getOrigin(Configuration.krpanoPlayerUrl),
    getOrigin(Configuration.apiEndPoint),
  ].filter(Boolean).forEach(origin => {
    appendLink('dns-prefetch', origin);
    appendLink('preconnect', origin);
  });
};

export const openVideoPlayer = (url, features) => {
  preconnectVideoPlayer();
  const playerWindow = window.open(url, '_blank', features);
  if (!playerWindow) {
    window.location.href = url;
  }
  return playerWindow;
};
